import { render } from "./CopyUsersIntoGroup.vue?vue&type=template&id=c4766b14&scoped=true"
import script from "./CopyUsersIntoGroup.vue?vue&type=script&lang=js"
export * from "./CopyUsersIntoGroup.vue?vue&type=script&lang=js"

import "./CopyUsersIntoGroup.vue?vue&type=style&index=0&id=c4766b14&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4766b14"]])

export default __exports__